import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Typography } from "components/typography";
import { ExpandableSection, Spacing, Spinner } from "@mindlercare/ui-web";
import { PatientBookings } from "./patientBookings";
import { useBookings } from "./useBookings";

type BookingsProps = {
  patientId: number;
};

export const Bookings = ({ patientId }: BookingsProps) => {
  const { t } = useTranslation();

  const { data: bookings } = useBookings(patientId);

  const getBookingsTranslation = (value: number) =>
    value === 1 ? t("BOOKING.one") : t("BOOKING.other");

  if (!bookings) return <Spinner />;
  return (
    <>
      <Box sx={{ mb: "1rem" }} />
      <ExpandableSection expanded={true}>
        <ExpandableSection.Toggle>
          <Typography insensitive variant="h4">
            {t("UPCOMING_SLOTS")}
          </Typography>
          <Spacing l={4} />
          <Typography insensitive variant="body" color="GRAY_DARK">
            {`- ${bookings?.upcoming?.length || 0} ${getBookingsTranslation(
              bookings?.upcoming?.length,
            )}`}
          </Typography>
        </ExpandableSection.Toggle>
        <ExpandableSection.Content>
          <Spacing l={4} t={8} />
          <PatientBookings bookings={bookings?.upcoming || []} />
        </ExpandableSection.Content>
      </ExpandableSection>

      <ExpandableSection>
        <ExpandableSection.Toggle>
          <Typography insensitive variant="h4">
            {t("PAST_SLOTS")}
          </Typography>
          <Spacing l={4} />
          <Typography insensitive variant="body" color="GRAY_DARK">
            {`- ${bookings?.past?.length || 0} ${getBookingsTranslation(
              bookings?.past?.length,
            )}`}
          </Typography>
        </ExpandableSection.Toggle>
        <ExpandableSection.Content>
          <Spacing l={4} t={8} />
          <PatientBookings bookings={bookings?.past || []} />
        </ExpandableSection.Content>
      </ExpandableSection>
    </>
  );
};
